









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Avatar extends Vue {
  @Prop()
  readonly image!: string

  @Prop()
  readonly text!: string;

  @Prop({ default: 'primary' })
  private type!: string;

  get firstChar () {
    return this.text ? this.text.split(' ').map(f => f.substring(0, 1)).join('') : ''
  }
}
